import {DEALER_FIND_ALL, DEALER_REQUEST_RESULT} from "../utils/Constant";

const dealers = function (state = {}, action) {
  switch (action.type) {
    case DEALER_FIND_ALL:

      return state;
    case DEALER_REQUEST_RESULT:
      return state;
    default :
      return state;
  }
}
export default dealers;
